module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("CHAPTER THREE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When I saw Celia lying there with a bullet in her neck, I was sadly unsurprised. And from the expression on her face, I would guess that Celia felt about the same the last time she felt anything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was a lanky crumple of green against the scuffed oak floor. There was yellow chalk outlining her body and a dime-size blot of red at her throat. Her slim dead legs were encased in the kind of hosiery women used to wear, with garters, and seams running up the backs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the bar there was an ashtray with Chesterfield butts in it, next to Celia’s patent-leather pocketbook. And also her saucer and cup, which was maybe a quarter-way full of milk streaked with Scotch. A forensic cop was dusting things with fingerprint powder for whatever good it could do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The twelve-year-olds had been herded back into the dining room. From the way some of them were sprawled in the banquettes, they had either fainted or thought murder was the floor show. The others were squawking as to how this would ruin all their plans for the evening. Nevertheless, "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v(" nobody was leaving for the time being and that included even the ones with their wristwatch alarms going off.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Over near the phone booth in front was a bulky redheaded detective of my slight acquaintance—Logue, from Central Homicide. I could not think of his first name, nor he mine as it turned out. He wore a square, brown suit and a brown tie and he held a pad of yellow paper in his puffy hand. He was asking Angelo questions—until he noticed me and waved me over.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logue came straight to it: “The proprietor, here, he tells me some of the things I need to know. Also he says, you, Hockaday, were one of the last persons besides the killer who talked to the deceased …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at Angelo. He was all right, except for his damp forehead and the fact that his skin had gone the color of Elmer’s glue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He tells me you’re on furlough, Detective Hockaday. But since you’re living right in the neighborhood, I asked him to give you a call over. As a professional consideration. So, you want to tell me anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, I want to. But I can’t. I knew the lady only a couple of minutes, long enough to see how there was a long story to her. But I never heard it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logue sucked his teeth. I asked him, “What can you tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He put the yellow pad back in his pocket and shook his fleshy head sideways. We shook hands since we had not done that yet. And then he disagreed with me some.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I don’t think there’s so much to say about her, or about the way she checked out,” Logue said. “Except you don’t have to be no Einstein to see it was personal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think so?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure I do. For one thing, where’s the signs of any struggles?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("There were none. It appeared that Celia had simply slid ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v(" off her barstool after getting herself quietly shot in a five o’clock crowd. Any cop would reasonably surmise that the shooter had been well acquainted with the victim, since any good cop will read a dead face the same as he would a live one. Also, any cop would assume the shooter was a professional; the job was done up-close and personal, neatly executed with a small-bore pistol so as not to make too much noise. Then the shooter had simply walked away in the crowd and commotion of happy hour, leaving Celia to fall down like an axed tree.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I asked Angelo, “What was she doing here all through the afternoon? And who came to join her recently?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Angelo thought for a few seconds, wanting to be careful and correct. He finally answered, slowly, “Celia and I talked about the old days. When she was a player—a gambler. Years ago she used to come here sometimes when we had some penny-ante stuff in the back room. Dice, mostly. Dice was her favorite.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Small chat like that, Hock. She had lunch at the bar, the fish-and-chips special. I gave her a lot of change for phone calls …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Calls from the booth in here?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. She was on the phone a whole lot when she wasn’t sitting at the bar, right where you met her earlier. I honestly don’t remember anybody coming in here asking to see her. And I don’t remember noticing that she talked to anybody, except on the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hock, if I could help, I would.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turned to Logue and asked him, “You already got that about the phone calls?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Logue said he had, that he was on top of it; he had already put in the police request for the New York Telephone Company to conduct a computer search of its coin-op logs for all outgoing calls from the booth at the Ebb Tide, between the hours of noon and half-past five. Logue added with a shrug, “For what it’s worth.” ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I asked what he meant by that crack.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know, Hock. This job’s just a nine-to-five, no overtime.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wanted to say “Maybe to you, Logue.” But I said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logue said wearily, “From what I seen and have been told so far, all we got here is the well-done cancellation of one …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He took the pad from his pocket and flipped through yellow pages. “One … Celia Furman, according to papers in her bag. Now also, according to the proprietor of the crime scene who knows her from bygone days, I am told that the late Ms. Furman was once-upon-a-time connected.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Connected how?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logue shrugged and so Angelo gave me the answer. “Gaming, that’s all, Hock. She started out in Detroit, as a cigarette girl in the sawdust houses. Remember them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I remembered. Back before a lot of people in my own neighborhood lost their jobs to the onslaught of legal gambling in the OTB parlors, and the state lotteries, and down in Atlantic City, there were colorful places all up and down the West Side where you could have drinks and a little music and shoot craps at the same time. Or play some tonk, or twenty-one. Some joints came equipped with wire rooms for playing the horses, or the national sports betting line. Every place had runners for the incidentals the clientele needed, like tip sheets for the races at Aqueduct or takeout Chinese or a fresh deck of cards. I remember all that because as a kid new to long pants, I myself was sometimes employed as a runner.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Now Angelo looked down at the body in the green dress with the good legs sticking out. “It’s hard for me to figure Celia ever doing anything so bad to somebody that she had to wind up this way. Now I see I didn’t know her so well as I thought.” ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“How well do we ever know anybody?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s very true.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then Logue said, “I’ll tell you what I make of all this. I think we have got here a case of somebody being out of circulation so long she was off-balance about her prospects for longevity. Now, ain’t that evident—and ain’t you seen it play that way before, Detective Hockaday?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean so off-balance that she forgot how you’re never out of the rackets, even when you’re not in the action?” I said, thinking out loud. “Maybe.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe nothing, that’s it,” Logue said. “Whatever she done and whoever she done it to, it all goes way back into something too murky for any of us to see. So that’s why I don’t get too excited about this being no more than a routine mop-up, even though it was a lady who got it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From Logue’s point of view, I could see that. Even so, I told him, “Celia told me how she once had tax trouble, and how it wrecked her life. There should be something in the way of leads there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe,” Logue said. “So I might get a few lines, so what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I asked Angelo again if he had seen her talking to anyone in particular. He shook his head and told me what he had already told Logue. “Honest, Hock. I’m so busy with this bad crowd that comes in nowadays, I just didn’t pay her any attention since about five.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logue stepped away from us, to speak to the police photographer who had just arrived. I told Angelo he should stop sweating so much. Then I joined Logue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The photographer stepped over and around the corpse in order to take pictures from every possible angle of what to him was just another lump. I heard somebody from the back dining room say, “Oh, ish!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("I looked at Celia’s face, white from the loss of blood and now whiter still in the strobe light. The corners of her lips ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v(" were turned up slightly, as if she had been sneering at somebody she knew well enough to despise. I saw that her hair was short and black and cut like women cut their hair back in the ’20s, like Louise Brooks in her bob. I had not noticed her hair before; she had been wearing a hat with a feather, but now it was nowhere around.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A spurt of blood escaped from one of her nostrils. I have seen enough of this sort of thing through the years to know that a tiny bullet was lodged in bone somewhere in Celia’s neck or head, and that her dead body was hemorrhaging. Soon every visible orifice would be leaking. The photographer knew this, too, which is why he was being quick about his role in the mop-up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“From the look of her,” I said to Logue, “I think the lady received unpleasant news.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s putting it mild,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I would also say that poor Celia Furman somehow half expected what happened was going to happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logue agreed. “Yeah, well, she don’t look shocked like most stiffs do. So how do you figure it played?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think she took some kind of bait to get set up like she was. That might come from being off-balance, like you said; in the rackets, you have to be figuring what awful thing can be done to you that is even worse than some awful thing you’re doing—or have done—to somebody else.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Makes sense.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sense, I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wanted a drink very badly right then. But I thought about meeting Ruby for dinner in a few hours and so instead I asked Angelo for a seltzer with lime.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then I asked Logue if he or the forensics officers had come across the shell casing to the bullet that was still somewhere inside Celia. He said no. “So what kind of piece did the shooter use, do you think?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("“I’d bet on a .25 automatic with blowback action,” Logue")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v(" said. “Notice how you don’t see no burns on her neck there, just the clean hole. An automatic’s quiet, too, and in a crowd it ain’t no trick to squeeze one off with nobody the wiser until they see somebody fall down on their face …”")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Which, in a bar, happens.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Happens, yeah.” Logue yawned and looked at his watch again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logue and I stood there silently, watching the forensics team pick up bar napkins with tweezers and dust things with sticky black powder and rummage through Celia’s pocket-book. Angelo rinsed out glasses behind the bar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The paramedics arrived and wrapped Celia head to toe in canvas, which happened also to be green. Then they took her away to the morgue in an ambulance, but they did not bother with the flashing light or the siren.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logue asked Angelo for change of a dollar. He muttered, “I got to call up the wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I asked the forensics cop now finished with Celia’s pocketbook if he had come across anything interesting. He recited the usual list of a lady’s gear, which is considerable. Then he showed me what he was about to slip into a plastic evidence bag—an old, curling, black-and-white snapshot, about two inches by three.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The details were hard to make out because of all the rips and creases in the photo paper, but there was no doubt about the main subject—a young, beautiful, high-spirited girl in a bathing suit, Celia on a boardwalk, in a frozen moment of her carefree past. Behind her was a Ferris wheel, and people walking by in shorts and straw hats. Along one crinkled margin of the snapshot was some writing in blue fountain-pen ink: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Coney I., summer ’54.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("The bathing beauty stood on the boardwalk between two men, each with an arm clasped around her slender waist. One of them was Celia’s height, or slightly taller. The other was shorter by at least two inches, and thickset. ")]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I noticed the shorter man’s bearded chin. And his glasses, and his beret.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Logue had finished talking to his wife and was standing beside me again, telling me how he was going to call it a day and how he did not see much percentage in the usual business of closing and sealing the scene himself. And that if I thought of anything useful to the cause, then maybe I ought to ring him at Central Homicide, “… for what it’s worth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For what it was worth, I decided to sleep on my thoughts at least one night. At the same time, I told myself again, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You can let all this wormy stuff go now …")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But of course, I could not. I asked Logue, “Did anybody find a green hat with a feather, a hat Celia’s size?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hat? She wore a hat?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I said yes. Logue said no, nobody found a hat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I said, “Maybe I’ll drop by to see you sometime in the next day or two.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Logue yawned and left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then I asked Angelo about the painting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That I got back in the early ’60s, sometime when you were up studying at City College, Hock. Now I don’t think I want it hanging here anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because it’s her in the picture—Celia?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s her, please God.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("Angelo turned to the back bar and picked up a bottle of Johnnie Walker red. He offered me a jar on the house, which I reluctantly declined in the interest of my dinner plans. He poured one for himself, though, and stared sadly at the thick amber. In the back room, where Celia threw craps once-upon-a-time, the uniforms were nearly finished with the happy hour types. I heard one of them complain, “But, Officer—this is, like, so inconvenient!” Angelo tipped his glass, spilling a few drops of Scotch out of respect for his circle of absent friends, now increased by one. ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He put back the whiskey, then raised the empty glass to toast the painting of Celia and himself. I asked who the artist was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That would be Celia’s long-lost husband, Charlie Furman.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If Charlie had come in here today,” I asked, “would Celia have recognized him? Would you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Charlie Furman, in here?” Angelo shook his head. “I don’t think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you know him, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I met him a few times if that’s what you mean. I only talked to him about what he wanted in the way of a drink, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But, here at the bar, that’s where you met him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, a long time back when he would sometimes come by with Celia. She’d go in the back and shoot craps and he’d sit up here drinking and watching the scenery. Man, the guy was quite the watcher.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why do you call him Celia’s ‘long-lost’ husband?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Celia and Charlie, they had lots of problems. First, Celia’s line is not conducive to long marriages; second, Charlie was an artist and artists are mostly nuts. He drifted off someplace and when he went Celia also cleared out the paintings the guy never sold, which in my case is what you see hanging over the bar.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s a street character here in the neighborhood who calls himself Picasso,” I said. There was no recognition in Angelo’s face. “Know him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Angelo thought and said, “No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I told myself, You’ve gone as far as you can … call up Logue tomorrow and tell him what you know; it’s his case, and besides, you’re on furlough!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I started to leave. The happy hour crowd was given its liberty; the front bar started filling up.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Angelo said, “Funny, isn’t it?” ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Funny how she wore green in the painting and how she wore green today.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The lady liked green?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("“She almost always wore green. She said it was her lucky color.” ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a883d0d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter03.vue
// module id = 87
// module chunks = 0